import { render, staticRenderFns } from "./TestCandidates.vue?vue&type=template&id=3874373d&scoped=true&"
import script from "./TestCandidates.vue?vue&type=script&lang=js&"
export * from "./TestCandidates.vue?vue&type=script&lang=js&"
import style0 from "./TestCandidates.vue?vue&type=style&index=0&id=3874373d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3874373d",
  null
  
)

export default component.exports